// extracted by mini-css-extract-plugin
export default {"smallButton":"button_smallButton__5di4F"};